export const useCrispComposable = () => {
  const { public: publicConfig } = useRuntimeConfig();
  const nuxtApp = useNuxtApp();

  const isCrispLoaded = (): boolean => {
    return (
      typeof window !== "undefined" && typeof window.$crisp !== "undefined"
    );
  };
  const initializeCrisp = () => {
    nuxtApp.$crisp.configure(publicConfig.crispWebsiteId);
    const userStore = useUserStore();
    if (userStore.getUser?.username) {
      nuxtApp.$crisp.session.setData({
        email: userStore.getUser.email,
        nickname: userStore.getUser.username,
        phone: null,
        avatar: userStore.getUser.avatar,
        user_id: userStore.getUser.id,
      });

      $crisp.push([
        "set",
        "session:data",
        [
          [
            [
              "order-invoices",
              `${userStore.getUser?.order_invoice_codes?.join(", ")}`,
            ],
            ["data-source", "initialize-crisp"],
          ],
        ],
      ]);
      nuxtApp.$crisp.user.setEmail(userStore.getUser?.email);
      nuxtApp.$crisp.user.setNickname(userStore.getUser?.username);
    }
    removeEvent();
  };

  const userToCrisp = () => {};

  const setUserDataToCrisp = (user: any) => {
    console.log(user);
    if (user.id) {
      nuxtApp.$crisp.session.setData({
        email: user.email,
        nickname: user.username,
        phone: ``,
        avatar: user.avatar,
      });
      $crisp.push([
        "set",
        "session:data",
        [
          [
            ["order-invoices", `${user.tags?.join(", ")}`],
            ["data-source", "set-user-data-to-crisp"],
          ],
        ],
      ]);
    }
  };
  const openChat = () => {
    nuxtApp.$crisp.chat.open();
  };
  const removeEvent = () => {
    window.removeEventListener("scroll", initializeCrisp);
  };
  return {
    initializeCrisp,
    userToCrisp,
    isCrispLoaded,
    openChat,
    setUserDataToCrisp,
  };
};
